// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__Fh9OL","image":"Hero_image__DjGKN"};